import languages from './languages';

/*
  Resolve the user's preferred language from the browser, mapped to one
  of our supported codes (falls back to 'en' if nothing matches).

  ORDER MATTERS:
    1. navigator.languages / navigator.language  — the user's *content
       language* preference. What they want to READ. On Android this
       comes from Chrome/Brave Settings → Languages.
    2. Intl.DateTimeFormat / Intl.NumberFormat   — the OS *formatting
       locale* (date/number format). On mobile this is often locked to
       the device region (e.g. 'en-GB' on a UK-region phone) regardless
       of what language the user actually picked. Only useful as a last
       resort.

  Putting Intl first was breaking mobile detection: a user with Brave
  set to Japanese but phone region UK would get navLanguage='ja-BD' and
  intlDate='en-GB' — and we'd resolve to 'en' because Intl was checked
  first and 'en' is in our supported list.
*/
const getSystemLanguage = () => {
  const supported = languages.map((l) => l.code);
  const candidates = [];

  if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages))
      candidates.push(...navigator.languages);
    if (navigator.language) candidates.push(navigator.language);
  }

  try {
    candidates.push(Intl.DateTimeFormat().resolvedOptions().locale);
  } catch (e) {}

  try {
    candidates.push(Intl.NumberFormat().resolvedOptions().locale);
  } catch (e) {}

  for (const raw of candidates) {
    if (!raw) continue;
    const base = String(raw).toLowerCase().split('-')[0];
    if (supported.includes(base)) return base;
  }

  return 'en';
};

export default getSystemLanguage;
